export default __webpack_public_path__ + "partner_49b2a3e.png";